import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';

import ControlModel    from 'ControlModel.js';
import NumericInputControlView  from 'common-inputs/NumericInputControlView.js';


//=============================================================================
//
// Creates a numeric input control, given a factoryService
// parameter key and a layout position. The factory key defines the
// control appearance through its template. It defines the initial rectangle
// of the control via a width and height from the factory parameter.
//
// Alfonso Cabral, January 26, 2016
//
//=============================================================================
class ControlInputNumericFactory extends BaseVisualControlFactory {

    constructor () {
        super();
    }

    createView( factoryKey, pos ) {

        const attributes = this.createChildAttributes( factoryKey, pos ) ;

        //adding silent(accessibility) to attributes.
        attributes.silent = false;
        attributes.alignLeftSelection = 'lightgrey';
        attributes.alignCenterSelection = 'transparent';
        attributes.alignRightSelection = 'transparent';

        attributes.styleColorText ='~inputTextColor';
        attributes.fontFamily = '~inputFont';
        attributes.fontSize = '~inputFont';
        attributes.textWeight = '~inputFont';
        attributes.textStyle  = '~inputFont';
        attributes.borderStyle= '~inputBorder';
        attributes.borderSize= '~inputBorder';
        attributes.cornerRadius= '~inputBorder';
        attributes.borderColor = '~inputBorderColor';
        attributes.backgroundColor = '~inputBgColor';
		attributes.inlineEditable = true;

        attributes.text = '0';
        attributes.numericText = '';
        attributes.allowNegative = true;
        attributes.min = constants.NUMERIC_INPUT_MIN_VALUE;
        attributes.max = constants.NUMERIC_INPUT_MAX_VALUE;
        attributes.minMaxMaxCharsLength = 13; //Defines the maximum characters length of min and max field properties
        attributes.decimalLength = 2;
        attributes.maxDecimalLength = 3; //Defines the maximum length of decimal length field properties
        attributes.maxDecimalCharsLength = 1; //Defines the maximum chars length of decimal length field properties        
        attributes.showLeadingZero = true;
        attributes.decimalSeparator = '.';
        attributes.thousandsSeparator = ',';
        attributes.symbol = '';
        attributes.paddingEnabled = false;
        attributes.paddingAmmount = 1;
        attributes.paddingAlignment = 'Leading';
        attributes.resizePadding = 12;
        attributes.align = 'right';
		attributes.minWidth = 30;
		attributes.lowestHeight = 10;
        this.resolveForInitialMinHeight(attributes);
        attributes.translateProps = [
            {key:"obligatoryMessage", label:"Mandatory Message"},
            {key:"toolTip", label:"Tooltip"},
            {key:"accessDesc", label:"Accessibility Description"},
        ];
        
        const view = new NumericInputControlView( { model: new ControlModel( attributes ),  el: $(constants.FORM_ID),
            pos: pos, factoryKey: factoryKey, id: attributes.id } );

        return view;
    }

}

const controlInputNumericFactory = new ControlInputNumericFactory();

export default controlInputNumericFactory;